export {
  Skeleton,
  SkeletonCard,
  SkeletonList,
} from '@/shared/ui/shadcn/skeleton';
